import { Dialog } from "@headlessui/react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Copy from "../../../../components/icons/copy";
import Download from "../../../../components/icons/download";
import Pencil from "../../../../components/icons/pencil";
import Trash from "../../../../components/icons/trash";
import {
  ChartListResponse,
  ChartStatusColorEnum,
  ChartStatusEnum,
} from "../../../../models/chart";

type ChartDisplayProps = {
  chart: ChartListResponse;
  deleteChart: (id: string) => void;
  downloadChart: (id: string) => void;
};

const ChartDisplay = (props: ChartDisplayProps) => {
  const navigate = useNavigate();
  const { chart, deleteChart, downloadChart } = props;
  const [openDelete, setOpenDelete] = useState<boolean>(false);

  const doDelete = () => {
    setOpenDelete(false);
    deleteChart(chart.id);
  };

  return (
    <>
      <div className="w-full border cursor-pointer bg-white shadow-sm rounded-lg flex items-center justify-items-stretch">
        <div className="w-full">
          <Link to={`edit-chart/${chart.id}`}>
            <div
              className={`pt-14 pl-10 pr-4 ${chart.status === "InProgress" ? "pb-6" : "pb-14"
                } flex-grow mb-4 relative flex items-center text-left justify-start w-full outline-none focus:outline-none`}
            >
              <div className="flex-grow">
                <div className="uppercase text-primary-blue text-lg font-semibold tracking-[0.07rem]">
                  {chart.municipality}
                </div>
                <div className="text-sm font-light text-gray-500 my-2">
                  Precinct {chart.precinct} | {chart.county} County |{" "}
                  {chart.electionDate.split("T")[0]}
                </div>
                {chart.status === "InProgress" && (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      navigate("duplicate-chart/" + chart.id);
                    }}
                    className="flex items-center gap-2 mt-4"
                  >
                    <Copy className="h-6 w-6" />{" "}
                    <span className="font-semibold text-primary-blue text-sm">
                      Duplicate Chart
                    </span>
                  </button>
                )}
              </div>
              <div
                className={`absolute -bottom-2 right-0 mx-2 px-2 py-0.5 text-sm uppercase rounded tracking-[0.07rem] ${ChartStatusColorEnum[
                  chart.status as keyof typeof ChartStatusColorEnum
                  ]
                  }`}
              >
                {ChartStatusEnum[chart.status as keyof typeof ChartStatusEnum]}
              </div>
              {chart.status === "InProgress" && (
                <>
                  <button
                    className="absolute -top-4 right-12 h-12 w-12 bg-gray-200 rounded-full flex items-center justify-center"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      setOpenDelete(true);
                    }}
                  >
                    <Trash className="h-6 w-6" />
                  </button>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      navigate("edit-chart/" + chart.id);
                    }}
                    className="absolute -top-4 -right-4 h-12 w-12 bg-gray-200 rounded-full flex items-center justify-center"
                  >
                    <Pencil className="h-6 w-6" />
                  </button>
                </>
              )}
              {chart.status === "Completed" && (
                <>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      downloadChart(chart.id);
                    }}
                    className="absolute -top-4 -right-4 h-12 w-12 bg-gray-200 rounded-full flex items-center justify-center"
                  >
                    <Download className="h-6 w-6" />
                  </button>
                </>
              )}
            </div>
          </Link>
        </div>
      </div>
      <Dialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        className="fixed z-10 inset-0 overflow-y-auto"
      >
        <div className="flex items-center justify-center min-h-screen">
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
          <div className="relative bg-white shadow-md rounded-md max-w-md mx-auto p-12 text-center">
            <Dialog.Title className="text-2xl text-primary-blue mb-2 font-semibold tracking-[0.07rem]">
              DELETE CHART
            </Dialog.Title>
            <Dialog.Description className="my-4">
              Are you sure you want to delete this chart?
            </Dialog.Description>
            <div className="flex justify-center gap-2 items-center mt-8">
              <button
                onClick={() => setOpenDelete(false)}
                className="w-36 inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-transparent hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
              >
                CANCEL
              </button>
              <button
                onClick={doDelete}
                className="w-36 inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-white border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
              >
                DELETE
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ChartDisplay;
